import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { LuPresentation } from "react-icons/lu";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import Loader from "../../../components/Loader/Loader";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import * as styled from "../../../components/MaterialsLevel/MaterialsLevel.styled";
import { courseOf, fetchPlatformLessons, platformLessonUrl } from "../../../helpers/materials/platformLessons";

// «Матеріали → Уроки платформи → група → рівень»: уроки по юнітах книжки (Lead-in, Unit 1 …), клік — презентація
function PlatformLessons({ isAdmin }) {
  const { group, level } = useParams();
  const [lessons, setLessons] = useState(null);

  useEffect(() => {
    fetchPlatformLessons(courseOf(group, level))
      .then(setLessons)
      .catch(() => setLessons([]));
  }, [group, level]);

  if (!lessons) return <Loader />;

  return (
    <PagesWrapper>
      <PlatformLessonList title={`Уроки платформи · ${level}`} lessons={lessons} isAdmin={isAdmin} />
    </PagesWrapper>
  );
}

// Список уроків курсу по юнітах — і для вчителя/адміна, і в «Матеріалах» учня на платформі
export function PlatformLessonList({ title, englishLevel, lessons, isAdmin, children }) {

  // Юніти в порядку уроків
  const units = [];
  lessons.forEach((lesson) => {
    const name = lesson.unit || "Уроки";
    let unit = units.find((u) => u.name === name);
    if (!unit) units.push((unit = { name, title: lesson.unitTitle, lessons: [] }));
    unit.lessons.push(lesson);
  });

  return (
    <>
      <TopPageTitle value={title} englishLevel={englishLevel} />
      <styled.MaterialsWrapper>
        {units.length === 0 && <p>Для цього рівня ще немає уроків платформи.</p>}
        {units.map((unit) => (
          <styled.TopicWrapper key={unit.name}>
            <styled.TopicName>
              {unit.name}
              {unit.title ? ` · ${unit.title}` : ""}
            </styled.TopicName>
            <styled.List>
              {unit.lessons.map((lesson, index) => (
                <styled.Item key={lesson._id} isAlternate={index % 2 !== 0}>
                  {/* Урок — в окремій вкладці, щоб не перекривати кабінет */}
                  <styled.LessonName as={Link} to={platformLessonUrl(lesson.lessonId)} target="_blank" rel="noopener">
                    <span>
                      Lesson {lesson.number}
                      <br />
                      <small>
                        {lesson.code && lesson.code !== unit.name ? `${lesson.code} · ` : ""}
                        {lesson.title}
                      </small>
                    </span>
                    <LuPresentation size={16} />
                  </styled.LessonName>
                  {isAdmin && lesson.status !== "published" && <styled.Draft>чернетка</styled.Draft>}
                </styled.Item>
              ))}
            </styled.List>
          </styled.TopicWrapper>
        ))}
        {children}
      </styled.MaterialsWrapper>
    </>
  );
}

export default PlatformLessons;
